module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/vi-bb9ab48d958b63def21cfd13a229fb83.jpg";